{
  "title": "Primal Savagery",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "Transmutation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "Self",
  "components": "S",
  "duration": "Instantaneous",
  "description": [
    "You channel primal magic to cause your teeth or fingernails to sharpen, ready to deliver a corrosive attack. Make a melee spell attack against one creature within 5 feet of you. On a hit, the target takes 1d10 acid damage. After you make the attack, your teeth or fingernails return to normal.",
    "At Higher Levels. The spell’s damage increases by 1d10 when you reach 5th level (2d10), 11th level (3d10), and 17th level (4d10)."
  ],
  "spellLists": ["druid"]
}
